import React from 'react';
import { FaStar, FaTrash } from 'react-icons/fa6';
import BreadcrumbsContainer from '../Breadcrumbs/BreadcrumbContainer';
import ActionButton from '../Buttons/ActionButton';
import { clearSelectedImageIds, selectImageIdsState, bumpImageListVersion } from '../../Store/imageSlice';
import { clearDoneByServerIds } from '../../Store/imageQueueSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useDeleteImageMutation } from '../../api/image';
import { useStarEntityMutation } from '../../api/favorite';

interface ImageActionButtonsProps {
    projectId: string;
}

export default function ImageActionButtons(props: ImageActionButtonsProps) {

    const { projectId } = props;

    const dispatch = useDispatch();
    const selectedImageIds = useSelector(selectImageIdsState);
    const [deleteImage, { isLoading: imageDeleteLoading, isError: imageDeleteError, isSuccess: imageDeleteSuccess }] = useDeleteImageMutation();
    const [starEntity, { isLoading: starLoading }] = useStarEntityMutation();

    const handleFavoriteClick = async () => {
        if (!selectedImageIds.length) return;
        for (let i = 0; i < selectedImageIds.length; i++) {
            try {
                await starEntity({ entityId: selectedImageIds[i], entityType: 'Image' }).unwrap();
            } catch (error) {
                console.log("error starring image", error);
            }
        }
        dispatch(clearSelectedImageIds());
    }

    const handleDeleteClick = async () => {
        console.log("selectedImageIds", selectedImageIds)
        if (!selectedImageIds.length) return;
        try{
            for(let i = 0; i < selectedImageIds.length; i++){
                console.log("deleting image", selectedImageIds[i])
                await deleteImage(selectedImageIds[i]).unwrap();
                console.log("image deleted", selectedImageIds[i])
            }
        }catch(error){
            console.log("error deleting image", error);
        }
        // a trashed image may still be a pending upload the list is standing in
        // for; drop those queue entries or the stand-in row outlives the image
        dispatch(clearDoneByServerIds(selectedImageIds))
        dispatch(clearSelectedImageIds())
        dispatch(bumpImageListVersion())
    }

    return (
        <BreadcrumbsContainer>
            <ActionButton text='Move to trash' Icon={FaTrash} onClick={handleDeleteClick} loading={imageDeleteLoading}/>
            <ActionButton text='Add to favorite' Icon={FaStar} onClick={handleFavoriteClick} loading={starLoading}/>
        </BreadcrumbsContainer>
    )
}